export const safetyActiveHeader = [
	{
		settings: true,
		text: "Driver name",
		value: "driver_name",
		func: false,
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "Truck",
		value: "truck",
		func: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Trailer",
		value: "trailer",
		func: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Service days",
		value: "count",
		func: false,
		filterable: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Week start day",
		value: "date_start",
		func: false,
		filterable: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Week end day",
		value: "date_end",
		func: false,
		filterable: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Amount",
		value: "amount",
		func: false,
		filterable: false,
		sortable: true,
		footer: "sum",
		dollar: true
	},
	{
		width: '40px',
		isRemoveAll: true,
		buttons: [
			{
				color: '#19BC38',
				margin: '0 auto',
				perm: true,
				value: 'delete',
				text: 'Delete',
				textAll: 'Delete all',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			}
		],
	}
];

export const safetyHeader = [
	{
		settings: true,
		text: "Driver name",
		value: "driver_name",
		func: false,
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "Truck",
		value: "truck",
		func: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Trailer",
		value: "trailer",
		func: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Service days",
		value: "count",
		func: false,
		filterable: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Week start day",
		value: "date_start",
		func: false,
		filterable: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Week end day",
		value: "date_end",
		func: false,
		filterable: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Amount",
		value: "amount",
		func: false,
		filterable: false,
		sortable: true,
		footer: "sum",
		dollar: true
	},
	{
		width: '40px',
		isAddAll: true,
		buttons: [
			{
				color: '#19BC38',
				margin: '0 auto',
				perm: true,
				value: 'plus',
				text: 'Add',
				textAll: 'Add all',
				icon: { value: 'plus', w: 16, h: 16 },
			},
		],
	}
];

export const billingActiveHeader = [
	{
		settings: true,
		text: "Origin and destination",
		value: "routs",
		func: false,
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "Pick-up date",
		value: "pick_up_datetime",
		func: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Del-ry date",
		value: "delivery_datetime",
		func: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Load#",
		value: "load_id",
		func: false,
		filterable: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Truck#",
		value: "truck",
		func: false,
		filterable: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Load type",
		value: "load_type",
		func: false,
		filterable: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Gross",
		value: "gross",
		func: false,
		filterable: false,
		sortable: true,
		footer: "sum",
		dollar: true
	},
	{
		settings: true,
		text: "Trailer",
		value: "trailer_type",
		func: false,
		filterable: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Rate",
		value: "percent",
		func: false,
		filterable: false,
		sortable: true
	},
	{
		settings: true,
		text: "Payment",
		value: "amount",
		func: false,
		filterable: false,
		sortable: true,
		footer: "sum",
		dollar: true
	},
	{
		width: '40px',
		isAddAll: true,
		buttons: [
			{
				color: '#19BC38',
				margin: '0 auto',
				perm: true,
				value: 'plus',
				text: 'Add',
				textAll: 'Add all',
				icon: { value: 'plus', w: 16, h: 16 },
			},
		],
	}
];

export const billingHeader = [
	{
		settings: true,
		text: "Origin and destination",
		value: "routs",
		func: false,
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "Pick-up date",
		value: "pick_up_datetime",
		func: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Del-ry date",
		value: "delivery_datetime",
		func: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Load#",
		value: "load_id",
		func: false,
		filterable: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Truck#",
		value: "truck",
		func: false,
		filterable: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Load type",
		value: "load_type",
		func: false,
		filterable: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Gross",
		value: "gross",
		func: false,
		filterable: false,
		sortable: true,
		footer: "sum",
		dollar: true
	},
	{
		settings: true,
		text: "Trailer",
		value: "trailer_type",
		func: false,
		filterable: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Rate",
		value: "percent",
		func: false,
		filterable: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Payment",
		value: "amount",
		func: false,
		filterable: false,
		sortable: true,
		footer: "sum",
		dollar: true
	},
	{
		width: '40px',
		isRemoveAll: true,
		buttons: [
			{
				color: '#19BC38',
				margin: '0 auto',
				perm: true,
				value: 'delete',
				text: 'Delete',
				textAll: 'Delete all',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			}
		],
	}
];

export const viewLoadActionsTable = [
	{
		settings: true,
		text: "Time",
		value: "date",
		valueFilter: 'filter_date',
		model: { value: 'date' },
		func: false,
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "User",
		value: "user",
		valueFilter: 'filter_name',
		model: { value: 'list' },
		func: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Log",
		value: "text",
		valueFilter: 'filter_type',
		model: { value: 'list' },
		func: false,
		sortable: true,
		modValue: 'modLog'
	},

	{
		width: '80px',
		isAddAll: false,
		buttons: [
			{
				color: '#19BC38',
				margin: '0 auto',
				perm: true,
				value: 'edit1',
				text: 'Edit',
				textAll: 'Edit item',
				icon: { value: 'edit', w: 16, h: 16 },
			},
			{
				color: '#19BC38',
				margin: '0 auto',
				perm: true,
				value: 'delete1',
				text: 'Delete',
				textAll: 'Delete all',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			}
		],
	}
];
export const ChangeCompanyTable = [

	{
		settings: true,
		text: "Company",
		value: "customer",
		valueFilter: 'filter_company',
		model: { value: 'list' },
		func: false,
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "Date from",
		value: "from",
		valueFilter: 'filter_date',
		model: { value: 'date' },
		func: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Date to",
		value: "to",
		valueFilter: 'filter_date_to',
		model: { value: 'date' },
		func: false,
		sortable: true,
	},

	{
		width: '40px',
		isAddAll: false,
		buttons: [
			{
				color: '#19BC38',
				margin: '0 auto',
				perm: true,
				value: 'edit1',
				text: 'Edit',
				textAll: 'Edit item',
				icon: { value: 'edit', w: 18, h: 18 },
			},
		],
	}
];
export const UserListActions = [
	{
		settings: true,
		text: "Time",
		value: "create_at",
		valueFilter: 'filter_create_at',
		model: { value: 'date' },
		func: false,
		sortable: true,
		footer: "count",
		modValue: 'dateTime',
		width: '110px',
	},
	{
		settings: true,
		text: "Employee",
		value: "employee",
		valueFilter: 'filter_employee',
		model: { value: 'list' },
		func: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Actions",
		value: "notes",
		valueFilter: 'filter_notes',
		model: { value: 'list' },
		func: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Request",
		value: "request",
		valueFilter: 'filter_request',
		model: { value: 'list' },
		func: false,
		sortable: true,
	},
	{
		width: '80px',
		isAddAll: false,
		buttons: [

			{
				margin: '0 auto',
				perm: true,
				value: 'view',
				text: 'View',
				textAll: 'View File',
				icon: { value: 'eye', w: 18, h: 18 },
			},
			{
				margin: '0 auto',
				perm: true,
				value: 'edit',
				text: 'Edit',
				textAll: 'Edit item',
				icon: { value: 'edit', w: 18, h: 18 },
			},
			{
				margin: '0 auto',
				perm: true,
				value: 'delete',
				text: 'Delete',
				textAll: 'Delete file',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			},
		],
	}
];
export const driverHistorySafety = [
	{
		settings: true,
		text: "Date from",
		value: "date_start",
		valueFilter: 'filter_date',
		model: { value: 'date' },
		func: false,
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "Date to",
		value: "date_end",
		valueFilter: 'filter_date',
		model: { value: 'date' },
		func: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Rate amount (incl. drivers)",
		value: "amount",
		valueFilter: 'filter_date_to',
		model: { value: 'number' },
		func: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Customer",
		value: "customer",
		valueFilter: 'filter_company',
		model: { value: 'list' },
		func: false,
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "Manager",
		value: "manager",
		valueFilter: 'filter_manager',
		model: { value: 'list' },
		func: false,
		sortable: true,
	},
];
export const driverFileTable = [

	{
		settings: true,
		text: "Date created",
		value: "created_at",
		valueFilter: 'filter_date',
		model: { value: 'date' },
		func: false,
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "Create by",
		value: "created_by",
		valueFilter: 'filter_date_to',
		model: { value: 'date' },
		func: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Category",
		value: "category",
		valueFilter: 'filter_company',
		model: { value: 'list' },
		func: false,
		sortable: true,
	},
	{
		settings: true,
		text: "File name",
		value: "name",
		valueFilter: 'filter_company',
		model: { value: 'list' },
		func: false,
		sortable: true,
	},
	{
		width: '120px',
		isAddAll: false,
		buttons: [
			{
				margin: '0 auto',
				perm: true,
				value: 'eye',
				text: 'View',
				textAll: 'View File',
				icon: { value: 'eye', w: 18, h: 18 },
			},
			{
				margin: '0 auto',
				perm: true,
				value: 'download',
				text: 'Download',
				textAll: 'Download file',
				icon: { value: 'icon_download', w: 18, h: 18 },
				download: true,
			},
			{
				margin: '0 auto',
				perm: true,
				value: 'delete',
				text: 'Delete',
				textAll: 'Delete file',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			},
		],
	}

	// <div className="customer_file-item">Date created</div>
	// <div className="customer_file-item">Create by</div>
	// <div className="customer_file-item">Category</div>
	// <div className="customer_file-item">File name</div>
];
export const customerFileTable = [

	{
		settings: true,
		text: "Date created",
		value: "create_at",
		valueFilter: 'filter_date',
		model: { value: 'date' },
		func: false,
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "Employee",
		value: "employee",
		valueFilter: 'filter_date_to',
		model: { value: 'list' },
		func: false,
		sortable: true,
	},
	{
		settings: true,
		text: "File name",
		value: "name",
		valueFilter: 'filter_company',
		model: { value: 'list' },
		func: false,
		sortable: true,
	},
	{
		width: '120px',
		isAddAll: false,
		buttons: [
			{
				margin: '0 auto',
				perm: true,
				value: 'eye',
				text: 'View',
				textAll: 'View File',
				icon: { value: 'eye', w: 18, h: 18 },
			},
			{
				margin: '0 auto',
				perm: true,
				value: 'download',
				text: 'Download',
				textAll: 'Download file',
				icon: { value: 'icon_download', w: 18, h: 18 },
				download: true,
			},
			{
				margin: '0 auto',
				perm: true,
				value: 'delete',
				text: 'Delete',
				textAll: 'Delete file',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			},
		],
	}

	// <div className="customer_file-item">Date created</div>
	// <div className="customer_file-item">{ { create_at } }</div>
	// <div className="customer_file-item">{ { employee } }</div>
	// <div className="customer_file-item">{ { name } }</div>
];
export const logsHeader = [
	{
		settings: true,
		text: "Date/Time",
		value: "create_at",
		valueFilter: 'filter_date',
		model: { value: 'date' },
		func: true,
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "User",
		value: "name",
		valueFilter: 'filter_name',
		model: { value: 'list' },
		func: true,
		sortable: true,
	},
	{
		settings: true,
		text: "Log",
		value: "msg",
		valueFilter: 'filter_type',
		model: { value: 'list' },
		func: true,
		sortable: true,
		modValue: 'modLog'
	},

	// {
	// 	text: "Date/Time",
	// 	value: "filter_date",
	// 	func: true,
	// 	filterable: false,
	// 	sortable: true,
	// 	model: { value: 'date' }
	// },
	// { text: "User", value: "filter_name", func: true, filterable: false, sortable: true, model: { value: 'list' } },
	// { text: "Log", value: "filter_type", func: true, filterable: false, sortable: true, model: { value: 'list' } },
];

export const additionalHeader = [
	{
		settings: true,
		text: "Created date",
		value: "create_at",
		func: false,
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "Created by",
		value: "manager",
		func: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Description",
		value: "description",
		func: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Amount",
		value: "amount",
		func: false,
		filterable: false,
		sortable: true,
	},
	{
		width: '40px',
		isRemoveAll: true,
		buttons: [
			{
				color: '#19BC38',
				margin: '0 auto',
				perm: true,
				value: 'delete',
				text: 'Delete',
				textAll: 'Delete all',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			}
		],
	}
];

export const additionalActiveHeader = [
	{
		settings: true,
		text: "Created date",
		value: "create_at",
		func: false,
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "Created by",
		value: "manager",
		func: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Description",
		value: "description",
		func: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Amount",
		value: "amount",
		func: false,
		filterable: false,
		sortable: true,
	},
	{
		width: '40px',
		isAddAll: true,
		buttons: [
			{
				color: '#19BC38',
				margin: '0 auto',
				perm: true,
				value: 'plus',
				text: 'Add',
				textAll: 'Add all',
				icon: { value: 'plus', w: 16, h: 16 },
			},
		],
	}
];
